var s={CONTACTS:"Contacts",EYEGLASSES:"Prescription eyeglasses",SUNGLASSES:"Prescription sunglasses",SUNGLASSES_PLANO:"Plano sunglasses",ACCESSORIES:"Accessories",READERS:"Readers"};export{s as PRODUCT_TYPE};
//# sourceMappingURL=productType.js.map
